<template>
  <Modal v-bind:open="this.open" @close="this.closeModal">
    <div class="space-y-4">
      <div class="text-center">
        <h2 class="text-lg font-semibold text-gray-900">
          <p>Réclamation liée au contrat {{ planSaleId }}</p>
        </h2>
      </div>

      <Selector
        id="theme"
        label="Thème"
        name="theme"
        v-model="complaint.theme"
        :options="themeOptions"
        :required="true"
      />

      <Selector
        id="subtheme"
        label="Sous-thème"
        name="subtheme"
        v-model="complaint.subtheme"
        :options="subthemeOptions"
        :required="true"
      />

      <Selector
        id="channel"
        label="Canal"
        name="channel"
        v-model="complaint.channel"
        :options="channelOptions"
        :required="true"
      />

      <FormField id="subject" label="Sujet" name="s)ubject" v-model="complaint.subject" :required="true" />

      <FormField id="details" label="Détails" name="details" v-model="complaint.details" :required="true" />

      <FormField
        id="reception_date"
        label="Date de réception"
        name="reception_date"
        placeholder="Date de réception"
        v-model="complaint.receptionDate"
        type="date"
        :required="true"
      />

      <FormField
        id="requested_amount"
        label="Montant demandé"
        name="requested_amount"
        placeholder="€"
        v-model="complaint.requestedAmount"
        type="number"
      />
    </div>
    <div class="mt-6 flex justify-end">
      <GenericButton @click="createComplaint">Créer</GenericButton>
    </div>
  </Modal>
</template>

<script>
import { FormField } from "@estaly/ui";
import { Selector, Modal, GenericButton } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    Modal,
    Selector,
    FormField,
    GenericButton,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    planSaleId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      complaint: {
        status: "in_review",
        createdBy: "estaly",
        theme: null,
        subtheme: null,
        channel: null,
        subject: null,
        details: null,
        requestedAmount: null,
        receptionDate: new Date().toISOString().split("T")[0],
      },
    };
  },

  computed: {
    ...mapGetters("complaints", ["themes", "subthemes", "channels"]),

    themeOptions() {
      return this.themes().map((theme) => ({
        value: theme,
        label: this.$t(`complaints.theme.${theme}`),
      }));
    },

    subthemeOptions() {
      return this.subthemes().map((subtheme) => ({
        value: subtheme,
        label: this.$t(`complaints.subtheme.${subtheme}`),
      }));
    },

    channelOptions() {
      return this.channels().map((channel) => ({
        value: channel,
        label: this.$t(`complaints.channel.${channel}`),
      }));
    },
  },

  methods: {
    ...mapActions("notifications", ["notify"]),
    ...mapActions("complaints", ["create"]),

    closeModal: function () {
      this.$emit("close");
    },

    createComplaint: async function () {
      const response = await this.create({ data: { planSaleId: this.planSaleId, complaint: this.complaint } });
      if (!response?.success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "La réclamation est créée.",
      });

      this.closeModal();
    },
  },
};
</script>
